/* eslint-disable no-empty-pattern */
import axios from 'axios';
import { headers } from '@/_services/headers';
import { encrypt, decrypt } from '../../_services/encryption';
const state = {
    maritalStatus: [],
    title: [],
    nextOfKinRelationship: [],
    employmentStatus: []
};
const mutations = {
    SET_MARITAL_STATUS (state, data) {
        state.maritalStatus = data;
    },
    SET_TITLE (state, data) {
        state.title = data;
    },
    SET_NEXT_OF_KIN_RELATIONSHIP (state, data) {
        state.nextOfKinRelationship = data;
    },
    SET_EMPLOYMENT_STATUS (state, data) {
        state.employmentStatus = data;
    }
    
};
const actions = {
    // action to transaction change pin
    async changeTransactionPin({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await axios.post(`/Authentication/changeTransactionPin`, encryptedData, { headers });
            return response.data;
        }
    },
    // action to change security question
    async changeSecurityQuestion({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await axios.post(`/SecurityQuestion/changeSecurityQuestion`, encryptedData, { headers });
            return response.data;
        }
    },
    // action to change password
    async changePassword({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await axios.post(`/Authentication/changePassword`, encryptedData, { headers });
            return response.data;
        }
    },
    // reset security question
    async resetSecurityQuestion({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await axios.post(`/SecurityQuestion/resetSecurityQuestions`, encryptedData, { headers });
            return response.data;
        }
    },
    // create security question
    async createSecurityQuestion({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await axios.post(`/SecurityQuestion/createSecurityResponse`, encryptedData, { headers });
            return response.data;
        }
    },
    // reset transaction pin
    async resetTransactionPin({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await axios.post(`/Authentication/resetTransactionPin`, encryptedData, { headers });
            return response.data;
        }
    },
    // create pin 
    async createPin({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await axios.post(`/Authentication/createTransactionPin`, encryptedData, { headers });
            return response.data;
        }
    },
    // upgrade account
    async upgradeAccount({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Account/upgradeAccount`, encryptedData, { headers });
            return response.data;
        }
    },
    async upgradeAccountNew({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Account/upgradeAccountnew`, encryptedData, { headers });
            return response.data;
        }
    },
    // limit upgrade
    async limitUpgrade({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Account/upgradeLimit`, encryptedData, { headers });
            return response.data;
        }
    },
    async getMaritalStatus({ commit }) {
        let response = await this._vm.$http.get(`/Enum/GetMaritalStatus`, { headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        commit('SET_MARITAL_STATUS', userParseData);
        return response;
    },
    async getTitle({ commit }) {
        let response = await this._vm.$http.get(`/Enum/GetTitle`, { headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        commit('SET_TITLE', userParseData);
        return response;
    },
    async getNextOfKinRelationship({ commit }) {
        let response = await this._vm.$http.get(`/Enum/GetNextOfKinRelationship`, { headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        commit('SET_NEXT_OF_KIN_RELATIONSHIP', userParseData);
        return response;
    },
    async getEmploymentStatus({ commit }) {
        let response = await this._vm.$http.get(`/Enum/GetEmploymentStatus`, { headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        commit('SET_EMPLOYMENT_STATUS', userParseData);
        return response;
    },
    
};
const getters = {
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};